export const searchBy = {
  keyword: 'searchKeyword'
};

export const SERVICE_TYPE_OPTION = [
  { value: '1:入所系', label: '1:入所系' },
  { value: '2:通所系', label: '2:通所系' },
  { value: '3:特殊系', label: '3:特殊系' },
  { value: '4:小多機系', label: '4:小多機系' }
];
